export const bgFilterOptions = [
    {
        label: '< 20 mg/dL',
        operation(value) {
            return value < 20;
        },
    },
    {
        label: '20 - 53 mg/dL',
        operation(value) {
            return value >= 20 && value < 54;
        },
    },
    {
        label: '54 - 69 mg/dL',
        operation(value) {
            return value >= 54 && value < 70;
        },
    },
    {
        label: '70 - 130 mg/dL',
        operation(value) {
            return value >= 70 && value < 131;
        },
    },
    {
        label: '70 - 180 mg/dL',
        operation(value) {
            return value >= 70 && value <= 180;
        },
    },
    {
        label: '131 - 180 mg/dL',
        operation(value) {
            return value >= 131 && value <= 180;
        },
    },
    {
        label: '181 - 250 mg/dL',
        operation(value) {
            return value >= 181 && value <= 250;
        },
    },
    {
        label: '251 - 600 mg/dL',
        operation(value) {
            return value >= 251 && value <= 600;
        },
    },
    {
        label: '> 600 mg/dL',
        operation(value) {
            return value > 600;
        },
    },
];
